import { Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { useState } from 'react';

import PhoneInputStep from './InputPhoneStep';
import { PhoneVerificationModalProps, VerificationStep } from './types';
import VerifyPhoneStep from './VerifyPhoneStep';

function PhoneVerificationModal({ isOpen, onClose }: PhoneVerificationModalProps) {
  const [currentStep, setCurrentStep] = useState<VerificationStep>('INSERT_PHONE');
  const [phoneNumber, setPhoneNumber] = useState<string>();
  const [transactionId, setTransactionId] = useState<string>();

  const handleClose = () => {
    setCurrentStep('INSERT_PHONE');
    setPhoneNumber(undefined);
    setTransactionId(undefined);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size="xl" isCentered>
      <ModalOverlay />
      <ModalContent maxW="520px" borderRadius="8px">
        {currentStep === 'VERIFY_PHONE' && phoneNumber && transactionId ? (
          <VerifyPhoneStep
            onClose={handleClose}
            setStep={setCurrentStep}
            phoneNumber={phoneNumber}
            transactionId={transactionId}
            setTransactionId={setTransactionId}
          />
        ) : (
          <PhoneInputStep
            setStep={setCurrentStep}
            setPhoneNumber={setPhoneNumber}
            setTransactionId={setTransactionId}
            onClose={handleClose}
          />
        )}
      </ModalContent>
    </Modal>
  );
}

export default PhoneVerificationModal;
